/* @flow */
import Reflux from "reflux";

const GetCategoriesAction: RefluxAction<any> = Reflux.createAction({
    asyncResult: true
});
export default GetCategoriesAction;
